// extracted by mini-css-extract-plugin
module.exports = {"container":"Callout_container__I0FBL","text":"Callout_text__svQhn","icon_wrapper":"Callout_icon_wrapper__peNqu","heading":"Callout_heading__VZbeY"};